import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
import { TermsType, goRecentTerms } from 'src/utils/terms/zendeskApi';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  position: fixed;
  color: ${({
  theme
}) => theme.color.content7};
`;
const PrivacyPolicyView = () => {
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;
    const query = router.query;
    const lang = Array.isArray(query.lang) ? query.lang[0] : query.lang;
    goRecentTerms(TermsType.privacyPolicy, lang);
  }, [router.isReady, router.query]);
  return <LoadingIndicator size={32} data-sentry-element="LoadingIndicator" data-sentry-component="PrivacyPolicyView" data-sentry-source-file="PrivacyPolicy.tsx" />;
};
export default PrivacyPolicyView;